import React, { useState } from 'react';
import { parseHourInput, formatHourInput } from '../utils/hourInput';

export default function HourInput({ value, format, onChange, onValidityChange, disabled, label, id }) {
  const [draft, setDraft] = useState(null);
  const [invalid, setInvalid] = useState(false);
  const edit = text => {
    setDraft(text);
    const parsed = parseHourInput(text);
    setInvalid(parsed === null);
    onValidityChange(parsed !== null);
    if (parsed !== null) onChange(text.trim() ? parsed : '');
  };
  return <div className="w-24">
    <input id={id} type="text" inputMode={format === 'minutes' ? 'text' : 'decimal'} disabled={disabled} aria-label={label} aria-invalid={invalid} aria-describedby={invalid ? `${id}-error` : undefined}
      value={draft ?? formatHourInput(value, format)}
      onFocus={event => { setDraft(event.target.value); event.target.select(); }}
      onChange={event => edit(event.target.value)}
      onBlur={() => { if (!invalid) setDraft(null); }}
      placeholder={format === 'minutes' ? '0:00' : '0,00'}
      className={`rh-hour-input h-12 w-full rounded-lg border text-center text-sm font-normal focus:outline-none focus:ring-2 ${invalid ? 'border-red-400 focus:ring-red-200' : 'border-slate-200 focus:ring-blue-500'} ${Number(value) > 0 ? 'text-slate-800' : 'text-slate-400'}`} />
    {invalid && <p id={`${id}-error`} className="mt-1 text-xs text-red-600">De 0 à 24 h. Ex. : 7:30 ou 7,50.</p>}
  </div>;
}
